(() => {
  var __defProp = Object.defineProperty;
  var __defProps = Object.defineProperties;
  var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols = Object.getOwnPropertySymbols;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __propIsEnum = Object.prototype.propertyIsEnumerable;
  var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols)
      for (var prop of __getOwnPropSymbols(b)) {
        if (__propIsEnum.call(b, prop))
          __defNormalProp(a, prop, b[prop]);
      }
    return a;
  };
  var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));

  // src/lib/ensure-stylesheet.ts
  var loaded = /* @__PURE__ */ new Set();
  var ensureStylesheet = (href) => new Promise((resolve) => {
    if (loaded.has(href) || document.querySelector(`link[rel="stylesheet"][href="${href}"]`)) {
      loaded.add(href);
      resolve();
      return;
    }
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = href;
    link.onload = () => {
      loaded.add(href);
      resolve();
    };
    link.onerror = () => resolve();
    document.head.appendChild(link);
  });
  var hoistAndAwaitStylesheets = async (doc) => {
    const links = Array.from(doc.querySelectorAll('link[rel="stylesheet"]'));
    await Promise.all(links.map((l) => ensureStylesheet(l.href)));
    links.forEach((l) => l.remove());
  };

  // src/lib/upsell-render.ts
  var RENDER_SECTION = "cart-item-upsell-renderer";
  var noopLogger = { log: () => {
  }, warn: () => {
  } };
  var renderUpsellProduct = async (handle, variantId, logger = noopLogger) => {
    var _a;
    const variantParam = variantId ? `variant=${encodeURIComponent(variantId)}&` : "";
    const url = `/products/${handle}?${variantParam}sections=${RENDER_SECTION}`;
    logger.log(`  rendering ${url}`);
    const r = await fetch(url);
    if (!r.ok) {
      logger.warn(`  section render failed for "${handle}"`, r.status);
      return "";
    }
    const data = await r.json();
    const raw = data[RENDER_SECTION] || "";
    if (!raw) {
      logger.warn(
        `  section "${RENDER_SECTION}" missing in response for "${handle}"`
      );
      return "";
    }
    const doc = new DOMParser().parseFromString(raw, "text/html");
    await hoistAndAwaitStylesheets(doc);
    const html = ((_a = doc.querySelector("[data-cart-item-upsell-renderer]")) == null ? void 0 : _a.innerHTML) || "";
    if (!html) {
      logger.warn(
        `  [data-cart-item-upsell-renderer] selector not found for "${handle}"`
      );
    } else {
      logger.log(`  \u2713 rendered "${handle}" (${html.length} chars)`);
    }
    return html;
  };
  var renderUpsellCarousel = async (products, logger = noopLogger) => {
    if (!products.length) return { html: "", renderedCount: 0 };
    const slides = await Promise.all(
      products.map((p) => renderUpsellProduct(p.handle, p.variantId, logger))
    );
    const valid = slides.filter(Boolean);
    logger.log(
      `assembled carousel: ${valid.length}/${products.length} slides rendered`
    );
    if (!valid.length) return { html: "", renderedCount: 0 };
    const html = `
  <carousel-el class="carousel swiper carousel--cart-item-upsell" data-slides-per-view="2.4" data-slides-per-view-lg="3">
    <div class="swiper-wrapper">${valid.join("")}</div>
  </carousel-el>`;
    return {
      html,
      renderedCount: valid.length
    };
  };

  // src/lib/upsell-debug.ts
  var isUpsellDebug = () => {
    var _a;
    if ((_a = window.HotelCollection) == null ? void 0 : _a.debugRecommendations) return true;
    try {
      return new URLSearchParams(window.location.search).get("rebuy_debug") === "1";
    } catch (e) {
      return false;
    }
  };

  // src/recommendation-rebuy-provider.ts
  (() => {
    var _a;
    window.HotelCollection = window.HotelCollection || {};
    const REBUY_HOST = "https://rebuyengine.com";
    const FETCH_TIMEOUT_MS = 8e3;
    const UUID_COOKIE = "hc_rebuy_uuid";
    const UUID_MAX_AGE_S = 60 * 60 * 24 * 365;
    const CONFIG_ELEMENT_ID = "rebuy-config";
    const isDebug = isUpsellDebug;
    const log = (...args) => {
      if (isDebug()) console.log("[recs:rebuy]", ...args);
    };
    const warn = (...args) => {
      if (isDebug()) console.warn("[recs:rebuy]", ...args);
    };
    const maskedUrl = (url) => url.replace(/key=[^&]+/, "key=***");
    const readConfig = () => {
      var _a2, _b;
      const el = document.getElementById(CONFIG_ELEMENT_ID);
      if (!el || !el.textContent) {
        warn("config element #rebuy-config not found in DOM");
        return {};
      }
      try {
        const config = JSON.parse(el.textContent);
        log("config loaded", {
          hasApiKey: Boolean(config.apiKey),
          keyPrefix: ((_a2 = config.apiKey) == null ? void 0 : _a2.slice(0, 6)) + "\u2026",
          intentSources: (_b = config.intentSources) != null ? _b : "(none)"
        });
        return config;
      } catch (e) {
        warn("failed to parse #rebuy-config JSON");
        return {};
      }
    };
    const getSessionUuid = () => {
      const match = document.cookie.match(/(?:^|;\s*)hc_rebuy_uuid=([^;]+)/);
      if (match) {
        const uuid2 = decodeURIComponent(match[1]);
        log("session uuid (existing)", uuid2);
        return uuid2;
      }
      const uuid = crypto.randomUUID();
      document.cookie = `${UUID_COOKIE}=${uuid}; max-age=${UUID_MAX_AGE_S}; path=/; SameSite=Lax`;
      log("session uuid (new)", uuid);
      return uuid;
    };
    const getCartContext = async () => {
      try {
        const r = await fetch("/cart.js", { credentials: "same-origin" });
        if (!r.ok) {
          warn("cart.js fetch failed", r.status);
          return null;
        }
        const cart = await r.json();
        log("cart context", {
          item_count: cart.item_count,
          total_price: cart.total_price,
          items: cart.items.map((i) => ({
            product_id: i.product_id,
            handle: i.handle,
            qty: i.quantity
          }))
        });
        return cart;
      } catch (err) {
        warn("cart.js fetch threw", err);
        return null;
      }
    };
    const fetchWithTimeout = async (url, ms) => {
      const controller = new AbortController();
      const timeoutId = window.setTimeout(() => {
        warn(`request timed out after ${ms}ms`, maskedUrl(url));
        controller.abort();
      }, ms);
      try {
        return await fetch(url, {
          signal: controller.signal,
          credentials: "omit",
          headers: { Accept: "application/json" }
        });
      } finally {
        window.clearTimeout(timeoutId);
      }
    };
    const asNonEmptyString = (v) => typeof v === "string" && v.trim() ? v.trim() : void 0;
    const extractHeadings = (json) => {
      var _a2;
      if (!json || typeof json !== "object") return {};
      const metadata = json.metadata;
      if (!metadata || typeof metadata !== "object") return {};
      // A data source can route to another one (rule output {type:"endpoint"}) and exit;
      // matched_rules then describes only the hop, never the routed source's language
      // rules. metadata.widget.language is the RESOLVED language, so it survives the hop.
      const language = (_a2 = metadata.widget) == null ? void 0 : _a2.language;
      let title = asNonEmptyString(language == null ? void 0 : language.title);
      let superTitle = asNonEmptyString(language == null ? void 0 : language.super_title);
      let description = asNonEmptyString(language == null ? void 0 : language.description);
      const matched = metadata.matched_rules;
      if (Array.isArray(matched)) {
        for (const rule of matched) {
          const outputs = Array.isArray(rule == null ? void 0 : rule.output) ? rule.output : [];
          for (const out of outputs) {
            const value = asNonEmptyString(out == null ? void 0 : out.value);
            if (!value) continue;
            if (out.type === "widget.language.title" && !title) title = value;
            else if (out.type === "widget.language.super_title" && !superTitle)
              superTitle = value;
            else if (out.type === "widget.language.description" && !description)
              description = value;
          }
        }
      }
      return { title, superTitle, description };
    };
    const fetchProducts = async ({
      productId,
      variantId,
      limit,
      intent,
      sourceId
    }) => {
      var _a2, _b, _c;
      const config = readConfig();
      const key = config.apiKey;
      if (!key) {
        warn(
          'API key missing \u2014 add {apiKey} to <script id="rebuy-config"> in layout/theme.liquid'
        );
        throw new Error("Rebuy API key missing");
      }
      const resolvedSourceId = sourceId || ((_a2 = config.intentSources) == null ? void 0 : _a2[intent]) || void 0;
      if (!sourceId && resolvedSourceId) {
        log(
          `intent "${intent}" resolved to sourceId "${resolvedSourceId}" via intentSources config`
        );
      }
      sourceId = resolvedSourceId;
      const cart = await getCartContext();
      const params = new URLSearchParams();
      params.set("key", key);
      params.set("limit", String(limit));
      params.set("uuid", getSessionUuid());
      params.set("url", window.location.href);
      if (isDebug()) params.set("_cb", String(Date.now()));
      if (productId) params.set("shopify_product_ids", productId);
      if (variantId) params.set("shopify_variant_ids", String(variantId));
      if (cart) {
        params.set("cart_item_count", String(cart.item_count));
        params.set("cart_subtotal", String(cart.total_price));
        const seedByVariant = variantId ? cart.items.find((item) => String(item.variant_id) === String(variantId)) : void 0;
        const seedByProduct = cart.items.find((item) => String(item.product_id) === productId);
        const seedItem = seedByVariant || seedByProduct || cart.items[0];
        if (seedItem) {
          params.set("cart[items][0][product_id]", String(seedItem.product_id));
          params.set("cart[items][0][variant_id]", String(seedItem.variant_id));
          params.set("cart[items][0][quantity]", String(seedItem.quantity));
        }
      }
      const endpoint = sourceId ? "custom ruleset" : "recommended";
      const path = sourceId ? `/api/v1/custom/id/${encodeURIComponent(sourceId)}` : "/api/v1/products/recommended";
      const url = `${REBUY_HOST}${path}?${params.toString()}`;
      log(`\u2192 Rebuy request [${endpoint}]`, {
        productId,
        intent,
        limit,
        sourceId: sourceId != null ? sourceId : "(default)",
        url: maskedUrl(url)
      });
      const t0 = performance.now();
      const r = await fetchWithTimeout(url, FETCH_TIMEOUT_MS);
      const elapsed = Math.round(performance.now() - t0);
      if (!r.ok) {
        warn(`\u2190 Rebuy response error`, {
          status: r.status,
          elapsed: `${elapsed}ms`
        });
        throw new Error(String(r.status));
      }
      const json = await r.json();
      log(`\u2190 Rebuy raw response`, {
        status: r.status,
        elapsed: `${elapsed}ms`,
        body: json
      });
      const list = Array.isArray(json) ? json : Array.isArray(json.data) ? json.data : Array.isArray(json.products) ? json.products : [];
      if (!list.length) {
        warn("Rebuy returned empty list \u2014 check ruleset config or product ID");
      }
      log("response shape", {
        detectedKey: Array.isArray(json) ? "(bare array)" : Array.isArray(json.data) ? "data" : Array.isArray(json.products) ? "products" : "(unknown \u2014 check raw response)",
        totalCount: list.length,
        products: list.map((p) => ({
          handle: p.handle,
          title: p.title,
          id: p.id
        }))
      });
      const normalizeHandle = (h) => typeof h === "string" ? h.trim().toLowerCase().replace(/^\/+/, "").replace(/^products\//, "") : "";
      const normalizeVariantId = (p) => {
        var _a3, _b2, _c2, _d, _e, _f;
        const raw = String((_f = (_e = (_b2 = p.variant_id) != null ? _b2 : (_a3 = p.variant) == null ? void 0 : _a3.id) != null ? _e : (_d = (_c2 = p.variants) == null ? void 0 : _c2[0]) == null ? void 0 : _d.id) != null ? _f : "").trim();
        return /^\d+$/.test(raw) ? raw : "";
      };
      const cartHandles = new Set(
        ((_c = cart == null ? void 0 : cart.items) != null ? _c : []).map((i) => normalizeHandle(i.handle)).filter(Boolean)
      );
      const seen = /* @__PURE__ */ new Set();
      const products = [];
      let droppedNoHandle = 0;
      let droppedInCart = 0;
      let droppedDuplicate = 0;
      for (const p of list) {
        const handle = normalizeHandle(p == null ? void 0 : p.handle);
        if (!handle) {
          droppedNoHandle++;
          continue;
        }
        if (cartHandles.has(handle)) {
          droppedInCart++;
          continue;
        }
        if (seen.has(handle)) {
          droppedDuplicate++;
          continue;
        }
        seen.add(handle);
        products.push({ handle, variantId: normalizeVariantId(p) });
      }
      if (droppedNoHandle || droppedInCart || droppedDuplicate) {
        log("normalize: dropped items", {
          noHandle: droppedNoHandle,
          alreadyInCart: droppedInCart,
          duplicate: droppedDuplicate
        });
      }
      log(
        "final product list for rendering",
        products.map((p) => ({
          handle: p.handle,
          variantId: p.variantId || "(default)"
        }))
      );
      const headings = extractHeadings(json);
      if (headings.title || headings.superTitle) {
        log("Rebuy headings resolved", headings);
      }
      return __spreadProps(__spreadValues({
        products
      }, headings), {
        recommendationType: endpoint,
        resolvedSourceId: sourceId,
        rawCount: list.length,
        filteredCount: products.length
      });
    };
    window.HotelCollection.RebuyProvider = {
      async fetchHtml({ productId, variantId, limit, intent, sourceId }) {
        log("fetchHtml called", { productId, variantId, limit, intent, sourceId });
        const {
          products,
          title,
          superTitle,
          description,
          recommendationType,
          resolvedSourceId,
          rawCount,
          filteredCount
        } = await fetchProducts({
          productId,
          variantId,
          limit,
          intent: intent != null ? intent : "related",
          sourceId
        });
        const meta = {
          providerUsed: "rebuy",
          recommendationType,
          sourceId: resolvedSourceId,
          rawCount,
          filteredCount,
          renderedCount: 0
        };
        if (!products.length) {
          warn("no products to render \u2014 placement will be hidden");
          return { html: "", meta };
        }
        log(`rendering ${products.length} product(s) via Section Rendering API\u2026`);
        const { html, renderedCount } = await renderUpsellCarousel(products, {
          log,
          warn
        });
        meta.renderedCount = renderedCount;
        if (!html) {
          warn("no slides rendered \u2014 placement will be hidden");
          return { html: "", meta };
        }
        return { html, title, superTitle, description, meta };
      }
    };
    (_a = window.HotelCollection.RecommendationEngine) == null ? void 0 : _a.setProvider(
      window.HotelCollection.RebuyProvider
    );
    log("RebuyProvider registered");
  })();
})();
